import React from 'react';
import Home from './pages/Home';

const App = () => <Home />;

export default App;
